// @ts-nocheck
import * as d3 from 'd3'
import { useEffect, useRef } from 'react'

interface ErrorBarTimeSeriesChartProps {
  stats: Record<string, { avg: number; stdev: number }>
  years?: number[]
  width?: number
  height?: number
  color?: string
  label: string
}

export const ErrorBarTimeSeriesChart = ({
  stats,
  years = [2018, 2019, 2020, 2021, 2022, 2023, 2024],
  width = 320,
  height = 180,
  label,
}: ErrorBarTimeSeriesChartProps) => {
  const svgRef = useRef<SVGSVGElement | null>(null)
  useEffect(() => {
    const data = years.map(year => ({
      year,
      avg: stats[year]?.avg,
      stdev: stats[year]?.stdev,
    }))
    const svg = d3.select(svgRef.current)
    svg.selectAll('*').remove()
    svg.attr('width', width).attr('height', height)
    const margin = { top: 20, right: 20, bottom: 30, left: 40 }
    const x = d3
      .scaleBand()
      .domain(years.map(String))
      .range([margin.left, width - margin.right])
      .padding(0.2)
    const y = d3
      .scaleLinear()
      .domain([
        d3.min(data, d => (d.avg && d.stdev ? d.avg - d.stdev : d.avg) || 0) ?? 0,
        d3.max(data, d => (d.avg && d.stdev ? d.avg + d.stdev : d.avg) || 1) ?? 1,
      ])
      .nice()
      .range([height - margin.bottom, margin.top])
    // Axes
    svg
      .append('g')
      .attr('transform', `translate(0,${height - margin.bottom})`)
      .call(d3.axisBottom(x))
    svg
      .append('g')
      .attr('transform', `translate(${margin.left},0)`)
      .call(d3.axisLeft(y))
    // Error bars
    svg
      .append('g')
      .selectAll('line')
      .data(data)
      .join('line')
      .attr('x1', d => x(String(d.year)) + x.bandwidth() / 2)
      .attr('x2', d => x(String(d.year)) + x.bandwidth() / 2)
      .attr('y1', d => y((d.avg ?? 0) - (d.stdev ?? 0)))
      .attr('y2', d => y((d.avg ?? 0) + (d.stdev ?? 0)))
      .attr('stroke', '#fff')
      .attr('stroke-width', 1)
    // Caps
    svg
      .append('g')
      .selectAll('line')
      .data(data)
      .join('line')
      .attr('x1', d => x(String(d.year)) + x.bandwidth() / 2 - 8)
      .attr('x2', d => x(String(d.year)) + x.bandwidth() / 2 + 8)
      .attr('y1', d => y((d.avg ?? 0) - (d.stdev ?? 0)))
      .attr('y2', d => y((d.avg ?? 0) - (d.stdev ?? 0)))
      .attr('stroke', '#fff')
      .attr('stroke-width', 1)
    svg
      .append('g')
      .selectAll('line')
      .data(data)
      .join('line')
      .attr('x1', d => x(String(d.year)) + x.bandwidth() / 2 - 8)
      .attr('x2', d => x(String(d.year)) + x.bandwidth() / 2 + 8)
      .attr('y1', d => y((d.avg ?? 0) + (d.stdev ?? 0)))
      .attr('y2', d => y((d.avg ?? 0) + (d.stdev ?? 0)))
      .attr('stroke', '#fff')
      .attr('stroke-width', 1)
    // Avg points
    svg
      .append('g')
      .selectAll('circle')
      .data(data)
      .join('circle')
      .attr('cx', d => x(String(d.year)) + x.bandwidth() / 2)
      .attr('cy', d => y(d.avg ?? 0))
      .attr('r', 3)
      .attr('stroke', '#fff')
      .attr('fill', '#fff')
  }, [stats, years, width, height, label])

  return <svg ref={svgRef} width={width} height={height} />
}
